import React from "react";
import { Link } from "react-router-dom";

const ClassTabs = () => {
  const tabData = [
    { title: "Science Lab", image: "https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/p1.jpg", readMore: "/" },
    { title: "Computer Lab", image: "https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/com-1.jpeg", readMore: "/computer-lab" },
    { title: "Sports Facility", image: "https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/Sports_1.jpg", readMore: "/sports" },
    { title: "AI Robotics lab", image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Robotics.jpg", readMore: "/ai-robotics-lab" },
    { title: "Health and Wellbeing", image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Health-Wellbeing.jpg", readMore: "/" },
    { title: "School Hall", image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Auditorium.jpg", readMore: "/school-hall" },
    { title: "Safety And Security", image: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Safety-Security.jpg", readMore: "/" },
  ];

  return (
    <div className="class-tabs">
      <div className="tabs">
        {tabData.map((tab, index) => (
          <Link
            key={index}
            to={tab.readMore}
            className="tab"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex", // preserve flex layout inside tab
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div className="tabs-img">
              <img src={tab.image} alt={tab.title} className="tab-image" />
            </div>
            <div className="tab-title">{tab.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ClassTabs;
